import React, { useState, useEffect } from 'react';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <div className="hero-gradient"></div>
        <div className="hero-pattern"></div>
        <div className="floating-elements">
          <div className="floating-element floating-element--1"></div>
          <div className="floating-element floating-element--2"></div>
          <div className="floating-element floating-element--3"></div>
        </div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <div className={`hero-main ${isVisible ? 'hero-main--visible' : ''}`}>
            <div className="hero-badge">
              <svg className="hero-badge-icon" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
              </svg>
              <span className="hero-badge-text">Next-Gen AI Enterprise Solutions</span>
            </div>
            
            <h1 className="hero-headline">
              <span className="hero-headline-main">Building the Future of</span>
              {' '}
              <span className="hero-headline-accent">Intelligent Work</span>
            </h1>
            
            <p className="hero-subtext">
              We design and build intelligent systems that empower organizations to make 
              <strong> faster, smarter decisions</strong>. Experience AI that works <em>with you</em> — not for you.
            </p>
            
            <div className="hero-cta">
              <button 
                className="cta-primary"
                onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })}
              >
                <span>Explore KnowTrace</span>
                <svg className="cta-arrow" viewBox="0 0 20 20">
                  <path d="M7 3l7 7-7 7" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              
              <button 
                className="cta-secondary"
                onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
              >
                <span>Learn More</span>
              </button>
            </div>
          </div>
          
          <div className={`hero-visual ${isVisible ? 'hero-visual--visible' : ''}`}>
            <div className="hero-card hero-card--main">
              <div className="card-header">
                <div className="card-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <span className="card-title">KnowTrace AI</span>
              </div>
              <div className="card-content">
                <div className="insight-item">
                  <svg className="insight-icon" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <div className="insight-text">
                    <div className="insight-label">Knowledge Discovery</div>
                    <div className="insight-value">98% Accuracy</div>
                  </div>
                </div>
                <div className="insight-item">
                  <svg className="insight-icon" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
                  </svg>
                  <div className="insight-text">
                    <div className="insight-label">Processing Speed</div>
                    <div className="insight-value">&lt; 0.3s Response</div>
                  </div>
                </div>
                <div className="insight-item">
                  <svg className="insight-icon" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2z" clipRule="evenodd" />
                  </svg>
                  <div className="insight-text">
                    <div className="insight-label">Security Level</div>
                    <div className="insight-value">Enterprise Grade</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
